// Full HTML content for blog articles (rendered via dangerouslySetInnerHTML).
// Trusted, author-provided content. Keyed by slug.

export const ARTICLE_HTML = {
  "gerer-les-coleres-du-jeune-enfant": `
<style>
  .bd-root{
    --paper:#E7EEE4;
    --paper-alt:#FBF8F1;
    --ink:#33303A;
    --coral:#E3684E;
    --mustard:#E0A233;
    --sage:#7FA379;
    --rose:#F1C7BC;
    --tape:#F4E7A1;
    --shadow: rgba(51,48,58,0.18);
    background:var(--paper);
    background-image:
      radial-gradient(circle at 1px 1px, rgba(51,48,58,0.06) 1px, transparent 0);
    background-size: 18px 18px;
    color:var(--ink);
    font-family:'Quicksand', sans-serif;
    padding: 2.5rem 1.25rem 4rem;
    line-height:1.55;
  }
  .bd-root *{box-sizing:border-box;}
  .bd-wrap{ max-width: 920px; margin:0 auto; }
  .bd-eyebrow{
    display:inline-flex; align-items:center; gap:.5rem;
    font-family:'Kalam', cursive; font-weight:700;
    background:var(--coral); color:var(--paper-alt);
    padding:.35rem .9rem; border-radius: 3px 14px 3px 14px;
    font-size:.85rem; transform: rotate(-2deg);
    box-shadow: 3px 3px 0 var(--shadow);
  }
  .bd-title{
    font-family:'Kalam', cursive; font-weight:700;
    font-size: clamp(2rem, 5vw, 3.1rem);
    margin: .8rem 0 .4rem; line-height:1.08;
  }
  .bd-title .accent{ color:var(--coral); }
  .bd-sub{ font-size:1.05rem; max-width: 60ch; margin: 0 0 1.6rem; color:#4b4854; }
  .bd-byline{ display:flex; align-items:center; gap:.7rem; font-size:.92rem; color:#55525d; margin-bottom:2.4rem; flex-wrap:wrap; }
  .bd-byline .dot{ width:6px;height:6px;border-radius:50%;background:var(--sage); }
  .bd-byline strong{ color:var(--ink); }
  .comic{ display:grid; grid-template-columns: repeat(3, 1fr); gap: 2.1rem 1.6rem; margin: 1rem 0 3rem; }
  @media (max-width: 720px){ .comic{ grid-template-columns: 1fr 1fr; } }
  @media (max-width: 480px){ .comic{ grid-template-columns: 1fr; } }
  .panel{ position:relative; background: var(--paper-alt); border: 2.5px solid var(--ink); border-radius: 10px 14px 12px 9px; padding: .6rem .6rem .9rem; box-shadow: 5px 6px 0 var(--shadow); }
  .panel:nth-child(2){ transform: rotate(1deg); }
  .panel:nth-child(3){ transform: rotate(-1.3deg); }
  .panel:nth-child(4){ transform: rotate(-1deg); }
  .panel:nth-child(6){ transform: rotate(1.2deg); }
  .tape{ position:absolute; top:-14px; left: 50%; transform: translateX(-50%) rotate(-3deg); width: 62px; height: 22px; background: var(--tape); opacity:.85; box-shadow: 1px 1px 3px rgba(0,0,0,.15); }
  .weather{ position:absolute; top:8px; right:8px; width:34px;height:34px; background:var(--paper-alt); border:2px solid var(--ink); border-radius:50%; display:flex;align-items:center;justify-content:center; z-index:2; }
  .panel svg.scene{ width:100%; height:auto; display:block; margin-top:.3rem; }
  .panel-caption{ font-family:'Kalam', cursive; font-weight:700; font-size:1rem; text-align:center; margin-top:.5rem; }
  .panel-num{ font-family:'Kalam', cursive; font-size:.8rem; color:#8a8792; }
  .section-head{ font-family:'Kalam', cursive; font-weight:700; font-size:1.7rem; margin: 0 0 1rem; }
  .why-grid{ display:grid; grid-template-columns: repeat(3, 1fr); gap:1.1rem; margin-bottom: 2.6rem; }
  @media (max-width:680px){ .why-grid{ grid-template-columns:1fr; } }
  .why-card{ background:var(--paper-alt); border:2px solid var(--ink); border-radius: 12px 6px 12px 6px; padding:1.1rem 1.1rem 1.2rem; box-shadow: 4px 4px 0 var(--shadow); }
  .why-card .icon{ width:40px;height:40px;margin-bottom:.5rem; }
  .why-card h3{ font-family:'Kalam', cursive; font-size:1.08rem; margin:.2rem 0 .4rem; }
  .why-card p{ font-size:.92rem; margin:0; color:#4b4854; }
  .tips-grid{ display:grid; grid-template-columns: 1fr 1fr; gap:1.4rem; margin-bottom: 2.6rem; }
  @media (max-width:680px){ .tips-grid{ grid-template-columns:1fr; } }
  .tip-card{ border-radius: 10px; padding:1.3rem 1.4rem; border:2px solid var(--ink); }
  .tip-card.avoid{ background: var(--rose); }
  .tip-card.helps{ background: #DCEBD9; }
  .tip-card h3{ font-family:'Kalam', cursive; font-size:1.15rem; margin:0 0 .7rem; }
  .tip-card ul{ margin:0; padding-left:1.2rem; }
  .tip-card li{ margin-bottom:.5rem; font-size:.94rem; }
  .signoff{ background: var(--paper-alt); border:2px solid var(--ink); border-radius: 14px 8px 14px 8px; padding: 1.4rem 1.6rem; display:flex; gap:1.1rem; align-items:flex-start; box-shadow: 4px 4px 0 var(--shadow); }
  .signoff .avatar{ flex:0 0 auto; }
  .signoff p{ margin:.2rem 0 0; font-size:.95rem; color:#4b4854; }
  .signoff strong{ font-family:'Kalam', cursive; font-size:1.05rem; color:var(--ink); }
  .signoff .practice{ margin-top:.5rem; font-size:.88rem; color:#6b6874; font-style:italic; }
</style>
<div class="bd-root">
  <div class="bd-wrap">
    <header>
      <span class="bd-eyebrow">📖 Le carnet de Léa — Épisode 1</span>
      <h1 class="bd-title">Petit orage à la maison :<br>la colère de <span class="accent">Léo, 2 ans</span></h1>
      <p class="bd-sub">Une petite BD pour comprendre ce qui se passe vraiment dans la tête d'un enfant de deux ans quand la tempête éclate — et pourquoi ce n'est pas un caprice.</p>
      <div class="bd-byline">
        <span>Écrit par <strong>Léa</strong>, Éducatrice de Jeunes Enfants</span>
        <span class="dot"></span>
        <span>Guidance parentale à domicile</span>
      </div>
    </header>
    <section class="comic">
      <div class="panel">
        <div class="tape"></div>
        <div class="weather">
          <svg viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="6" fill="#E0A233"/><g stroke="#E0A233" stroke-width="2"><line x1="12" y1="1" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="23"/><line x1="1" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="23" y2="12"/></g></svg>
        </div>
        <svg class="scene" viewBox="0 0 300 210">
          <rect x="0" y="150" width="300" height="60" fill="#EFE6D2"/>
          <circle cx="150" cy="90" r="26" fill="#F3CBA0"/>
          <path d="M124 82 q26 -22 52 0" fill="#8B5E3C"/>
          <circle cx="141" cy="92" r="2.4" fill="#33303A"/>
          <circle cx="159" cy="92" r="2.4" fill="#33303A"/>
          <path d="M142 101 q8 5 16 0" stroke="#33303A" stroke-width="2" fill="none"/>
          <rect x="122" y="112" width="56" height="55" rx="14" fill="#E0A233"/>
          <path d="M112 150 q-10 10 -4 22" stroke="#F3CBA0" stroke-width="10" fill="none" stroke-linecap="round"/>
          <ellipse cx="102" cy="176" rx="16" ry="9" fill="#E3684E"/>
          <rect x="108" y="150" width="14" height="26" fill="#F3CBA0"/>
          <rect x="160" y="150" width="14" height="30" fill="#F3CBA0"/>
        </svg>
        <p class="panel-caption">« Je mets mes chaussures... tout seul ! »</p>
        <span class="panel-num">1/6</span>
      </div>
      <div class="panel">
        <div class="tape"></div>
        <div class="weather">
          <svg viewBox="0 0 24 24" width="22" height="16"><ellipse cx="12" cy="12" rx="10" ry="6" fill="#B7C9C4"/><ellipse cx="7" cy="10" rx="6" ry="5" fill="#B7C9C4"/><ellipse cx="16" cy="9" rx="6" ry="5" fill="#B7C9C4"/></svg>
        </div>
        <svg class="scene" viewBox="0 0 300 210">
          <rect x="0" y="150" width="300" height="60" fill="#EFE6D2"/>
          <circle cx="150" cy="90" r="26" fill="#F3CBA0"/>
          <path d="M124 82 q26 -22 52 0" fill="#8B5E3C"/>
          <path d="M138 90 q3 -4 6 0" stroke="#33303A" stroke-width="2" fill="none"/>
          <path d="M156 90 q3 -4 6 0" stroke="#33303A" stroke-width="2" fill="none"/>
          <path d="M140 104 q10 -4 20 0" stroke="#33303A" stroke-width="2.4" fill="none"/>
          <rect x="122" y="112" width="56" height="55" rx="14" fill="#E0A233"/>
          <path d="M108 148 q-16 -4 -20 8" stroke="#F3CBA0" stroke-width="10" fill="none" stroke-linecap="round"/>
          <ellipse cx="98" cy="172" rx="15" ry="9" fill="#E3684E" transform="rotate(-25 98 172)"/>
          <rect x="108" y="150" width="14" height="26" fill="#F3CBA0"/>
          <rect x="160" y="150" width="14" height="30" fill="#F3CBA0"/>
          <text x="205" y="70" font-family="Kalam" font-size="26" fill="#E0A233">?!</text>
        </svg>
        <p class="panel-caption">La chaussure résiste. La frustration monte.</p>
        <span class="panel-num">2/6</span>
      </div>
      <div class="panel">
        <div class="tape"></div>
        <div class="weather">
          <svg viewBox="0 0 24 24" width="22" height="20"><ellipse cx="12" cy="10" rx="10" ry="6" fill="#5B6B72"/><polygon points="11,14 15,14 9,23 13,16 10,16" fill="#E0A233"/></svg>
        </div>
        <svg class="scene" viewBox="0 0 300 210">
          <rect x="0" y="150" width="300" height="60" fill="#EFE6D2"/>
          <ellipse cx="150" cy="185" rx="45" ry="10" fill="#DCC9A0"/>
          <circle cx="120" cy="150" r="24" fill="#F3CBA0"/>
          <path d="M98 143 q22 -20 44 0" fill="#8B5E3C"/>
          <path d="M112 148 l6 6 M124 148 l-6 6" stroke="#33303A" stroke-width="2"/>
          <ellipse cx="118" cy="163" rx="6" ry="4" fill="#33303A"/>
          <rect x="140" y="140" width="70" height="34" rx="16" fill="#E0A233"/>
          <rect x="195" y="120" width="12" height="26" fill="#F3CBA0" transform="rotate(20 195 120)"/>
          <rect x="150" y="118" width="12" height="26" fill="#F3CBA0" transform="rotate(-35 150 118)"/>
          <path d="M60 60 q10 -14 24 -4" stroke="#E3684E" stroke-width="3" fill="none" stroke-linecap="round"/>
          <path d="M50 78 q10 -14 24 -4" stroke="#E3684E" stroke-width="3" fill="none" stroke-linecap="round"/>
          <path d="M230 55 q10 -14 24 -4" stroke="#E3684E" stroke-width="3" fill="none" stroke-linecap="round"/>
        </svg>
        <p class="panel-caption">BOUM. La tempête éclate pour de bon.</p>
        <span class="panel-num">3/6</span>
      </div>
      <div class="panel">
        <div class="tape"></div>
        <div class="weather" style="background:#DCEBD9;">
          <svg viewBox="0 0 24 24" width="18" height="18"><path d="M12 3a5 5 0 0 0-3 9c-1 1-1 3 0 4h6c1-1 1-3 0-4a5 5 0 0 0-3-9z" fill="#7FA379"/></svg>
        </div>
        <svg class="scene" viewBox="0 0 300 210">
          <rect x="0" y="0" width="300" height="210" fill="#F1ECDD"/>
          <circle cx="150" cy="100" r="70" fill="#FBF8F1" stroke="#33303A" stroke-width="2.5"/>
          <path d="M110 80 q40 -30 80 0 q10 30 -10 55 q-30 20 -60 0 q-20 -25 -10 -55 z" fill="#F1C7BC" stroke="#33303A" stroke-width="2"/>
          <circle cx="118" cy="100" r="12" fill="#E3684E"/>
          <text x="105" y="132" font-family="Kalam" font-size="10" fill="#33303A">alerte !</text>
          <circle cx="182" cy="90" r="10" fill="#DCEBD9" stroke="#33303A" stroke-width="1.5"/>
          <text x="150" y="188" font-family="Kalam" font-size="13" fill="#33303A" text-anchor="middle">« pilote » pas encore prêt</text>
        </svg>
        <p class="panel-caption">Dans son cerveau : l'alarme s'allume, le « frein » n'est pas encore installé.</p>
        <span class="panel-num">4/6</span>
      </div>
      <div class="panel">
        <div class="tape"></div>
        <div class="weather">
          <svg viewBox="0 0 24 24" width="22" height="16"><ellipse cx="10" cy="10" rx="8" ry="5" fill="#B7C9C4"/><circle cx="18" cy="12" r="5" fill="#E0A233"/></svg>
        </div>
        <svg class="scene" viewBox="0 0 300 210">
          <rect x="0" y="150" width="300" height="60" fill="#EFE6D2"/>
          <circle cx="90" cy="120" r="22" fill="#E8B98C"/>
          <path d="M70 114 q20 -18 40 0" fill="#5C4A3A"/>
          <rect x="66" y="140" width="48" height="46" rx="12" fill="#7FA379"/>
          <rect x="60" y="170" width="60" height="16" rx="8" fill="#7FA379"/>
          <circle cx="170" cy="140" r="22" fill="#F3CBA0"/>
          <path d="M150 133 q20 -18 40 0" fill="#8B5E3C"/>
          <path d="M162 141 q2 -3 5 0 M175 141 q2 -3 5 0" stroke="#33303A" stroke-width="1.8" fill="none"/>
          <path d="M162 150 q8 3 15 0" stroke="#33303A" stroke-width="1.8" fill="none"/>
          <rect x="150" y="160" width="42" height="40" rx="12" fill="#E0A233"/>
          <path d="M118 176 q10 6 22 2" stroke="#E8B98C" stroke-width="9" fill="none" stroke-linecap="round"/>
          <path d="M40 60 q0 -20 20 -20 h60 q20 0 20 20 v14 q0 20 -20 20 h-45 l-14 12 4 -12 h-5 q-20 0 -20 -20 z" fill="#FBF8F1" stroke="#33303A" stroke-width="2"/>
          <text x="60" y="78" font-family="Kalam" font-weight="700" font-size="12" fill="#33303A">Je vois que tu es</text>
          <text x="60" y="94" font-family="Kalam" font-weight="700" font-size="12" fill="#33303A">en colère. Je suis là.</text>
        </svg>
        <p class="panel-caption">Le parent devient l'ancre : calme, présent, sans discours.</p>
        <span class="panel-num">5/6</span>
      </div>
      <div class="panel">
        <div class="tape"></div>
        <div class="weather">
          <svg viewBox="0 0 24 24" width="20" height="20"><circle cx="12" cy="12" r="6" fill="#E0A233"/><g stroke="#E0A233" stroke-width="2"><line x1="12" y1="1" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="23"/><line x1="1" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="23" y2="12"/></g></svg>
        </div>
        <svg class="scene" viewBox="0 0 300 210">
          <rect x="0" y="150" width="300" height="60" fill="#EFE6D2"/>
          <circle cx="120" cy="115" r="24" fill="#E8B98C"/>
          <path d="M98 108 q22 -20 44 0" fill="#5C4A3A"/>
          <rect x="94" y="138" width="52" height="50" rx="14" fill="#7FA379"/>
          <circle cx="168" cy="128" r="20" fill="#F3CBA0"/>
          <path d="M150 122 q18 -16 36 0" fill="#8B5E3C"/>
          <path d="M160 128 q2 -2 4 0 M172 128 q2 -2 4 0" stroke="#33303A" stroke-width="1.6" fill="none"/>
          <path d="M160 136 q8 4 16 0" stroke="#33303A" stroke-width="1.6" fill="none"/>
          <rect x="150" y="146" width="40" height="38" rx="12" fill="#E0A233"/>
          <path d="M124 150 q16 8 30 2" stroke="#E8B98C" stroke-width="9" fill="none" stroke-linecap="round"/>
          <path d="M60 40 q6 -8 14 -2" stroke="#E0A233" stroke-width="2.4" fill="none" stroke-linecap="round"/>
          <path d="M230 50 q6 -8 14 -2" stroke="#E0A233" stroke-width="2.4" fill="none" stroke-linecap="round"/>
        </svg>
        <p class="panel-caption">La tempête passe. Toujours. Le calme revient.</p>
        <span class="panel-num">6/6</span>
      </div>
    </section>
    <section>
      <h2 class="section-head">Pourquoi c'est normal à cet âge</h2>
      <div class="why-grid">
        <div class="why-card">
          <svg class="icon" viewBox="0 0 40 40"><path d="M20 6a12 12 0 0 0-6 22c-2 2-2 6 0 8h12c2-2 2-6 0-8a12 12 0 0 0-6-22z" fill="#F1C7BC" stroke="#33303A" stroke-width="1.6"/></svg>
          <h3>Le cerveau n'est pas fini</h3>
          <p>La zone qui régule les émotions se construit encore. À 2 ans, l'enfant ressent tout très fort, mais n'a pas encore les moyens de se calmer seul.</p>
        </div>
        <div class="why-card">
          <svg class="icon" viewBox="0 0 40 40"><path d="M6 10h28v16H16l-6 6v-6H6z" fill="#DCEBD9" stroke="#33303A" stroke-width="1.6"/></svg>
          <h3>Les mots manquent</h3>
          <p>Il ressent une frustration précise, mais ne dispose pas encore du vocabulaire pour la dire. La colère devient alors le seul langage disponible.</p>
        </div>
        <div class="why-card">
          <svg class="icon" viewBox="0 0 40 40"><circle cx="20" cy="20" r="15" fill="#F4E7A1" stroke="#33303A" stroke-width="1.6"/><text x="20" y="26" font-family="Kalam" font-size="16" text-anchor="middle" fill="#33303A">moi</text></svg>
          <h3>Le besoin d'exister</h3>
          <p>« Tout seul ! » n'est pas de l'entêtement : c'est l'affirmation d'une identité qui se construit, en tension avec le besoin d'être encore accompagné.</p>
        </div>
      </div>
    </section>
    <section>
      <h2 class="section-head">Ce qui attise vs. ce qui apaise</h2>
      <div class="tips-grid">
        <div class="tip-card avoid">
          <h3>🌩️ Ce qui attise l'orage</h3>
          <ul>
            <li>Raisonner ou négocier pendant la crise</li>
            <li>Dire « arrête » ou « ce n'est rien »</li>
            <li>Céder pour que ça s'arrête vite</li>
            <li>S'énerver en miroir de sa colère</li>
          </ul>
        </div>
        <div class="tip-card helps">
          <h3>☀️ Ce qui aide à apaiser</h3>
          <ul>
            <li>Nommer l'émotion : « tu es en colère »</li>
            <li>Rester une présence calme et stable</li>
            <li>Proposer un choix limité (« ce pull ou celui-ci ? »)</li>
            <li>Accueillir le câlin une fois la tempête passée</li>
          </ul>
        </div>
      </div>
    </section>
    <div class="signoff">
      <div class="avatar">
        <svg width="52" height="52" viewBox="0 0 52 52"><circle cx="26" cy="26" r="26" fill="#F1C7BC"/><circle cx="26" cy="22" r="10" fill="#E8B98C"/><path d="M26 32c-9 0-14 5-14 12h28c0-7-5-12-14-12z" fill="#7FA379"/></svg>
      </div>
      <div>
        <strong>Un mot de Léa</strong>
        <p>Une colère n'est ni un caprice, ni un échec éducatif : c'est une étape du développement. Elle passe, et elle passe encore mieux accompagnée.</p>
        <p class="practice">Guidance parentale à domicile — accompagnement des familles avec de jeunes enfants, à Dijon.</p>
      </div>
    </div>
  </div>
</div>
`,
};
